/**
 * Renders a structured address object as a single line.
 *
 * Assembles from the parts rather than echoing `fullAddress`, so an address the
 * user has hand-corrected displays what they actually typed. Pass
 * `displayFullAddress` to prefer the provider's original string instead.
 */
export const formatAddressObjectFullAddress = (
  address,
  displayFullAddress = false,
) => {
  if (!address || typeof address !== "object") return "N/A";

  if (displayFullAddress && address.fullAddress) return address.fullAddress;

  const { streetNumber, streetName, unit, city, state, zip } = address;

  const streetLine = [streetNumber, streetName].filter(Boolean).join(" ");
  const unitPart = unit ? `, ${unit}` : "";
  const cityStateZip = [city, state, zip].filter(Boolean).join(" ");

  const formatted = [`${streetLine}${unitPart}`.trim(), cityStateZip]
    .filter(Boolean)
    .join(", ")
    .trim();

  return formatted || "N/A";
};

export default formatAddressObjectFullAddress;
